import React, { useState, useRef } from 'react';
import { IconButton, DefaultButton } from '@fluentui/react';
import { Icon } from '@fluentui/react';
import './HelpButton.scss';
import { Callout, DirectionalHint } from '@fluentui/react';
import { Link } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import { EventBus, EventNames } from '../../../shared/eventbus/eventbus';

interface IHelpButtonProps {
    className?: string;
}

let instanceCounter = 0;

const HelpButton: React.FC<IHelpButtonProps> = ({ className }) => {
    const navigate = useNavigate();
    const helpButtonIdRef = useRef<string | null>(null);
    if (helpButtonIdRef.current === null) {
        instanceCounter++;
        helpButtonIdRef.current = `HelpButton${instanceCounter}`;
    }
    const helpButtonId = helpButtonIdRef.current;

    const [isCalloutVisible, setIsCalloutVisible] = useState(false);

    const showCallout = () => setIsCalloutVisible(true);
    const dismissCallout = () => setIsCalloutVisible(false);

    const startAppTour = () => {
        dismissCallout();
        navigate('/');
        EventBus.emit(EventNames.StartApplicationTour);
    };

    const openFeedbackModal = () => {
        dismissCallout();
        EventBus.emit(EventNames.OpenFeedbackModal);
    };

    return (
        <>
            <DefaultButton
                className={`HelpButton ${className}`}
                title="Help"
                id={helpButtonId}
                ariaLabel="StatusCircleQuestionMark"
                onClick={showCallout}
            >
                <Icon iconName="Help" />
            </DefaultButton>
            <Callout
                className="HelpCallout"
                target={`#${helpButtonId}`}
                directionalHint={DirectionalHint.bottomCenter}
                onDismiss={dismissCallout}
                setInitialFocus={true}
                hidden={!isCalloutVisible}
            >
                <header>BCE Help</header>
                <hr />
                <div className="HelpLinkRow">
                    <Icon iconName="FileSymlink" />
                    <Link href="https://bce.service-now.com" target="_blank" rel="noopener noreferrer" onClick={dismissCallout}>
                        <span className="LinkText">Help Centre</span>
                    </Link>
                </div>
                <div className="HelpLinkRow">
                    <Icon iconName="MSNVideos" />
                    <Link onClick={startAppTour}>
                        <span className="LinkText">Show Screen Tour</span>
                    </Link>
                </div>
                <div className="HelpLinkRow">
                    <Icon iconName="Feedback" />
                    <Link onClick={openFeedbackModal}>
                        <span className="LinkText">Share Feedback</span>
                    </Link>
                </div>
                <IconButton className="CloseHelpButton" iconProps={{ iconName: 'Cancel' }} onClick={dismissCallout} />
            </Callout>
        </>
    );
};

export default HelpButton;
